if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.sliderMobileOnly = this.dataset.sliderMobileOnly === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.enableAutoplay = this.dataset.enableAutoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed || "5", 10);
      this.slideContainer = this.querySelector(".swiper-container");
      this.slider = null;
      this.mobileMql = null;
      this._legacyAutoplayMql = null;
      this._legacyAutoplaySync = null;
      this._onBlockSelect = (e) => this.onBlockSelect(e);
      this.handleLayoutMode = () => this._handleLayoutMode();
    }

    navPair(prevButton, nextButton) {
      if (!this.showNavigation || !prevButton || !nextButton) return false;
      return { prevEl: prevButton, nextEl: nextButton };
    }

    connectedCallback() {
      this.lastActive = null;
      if (!this.enableSlider || !this.slideContainer) return;

      document.addEventListener("shopify:block:select", this._onBlockSelect);

      if (this.sliderMobileOnly) {
        this.mobileMql = window.matchMedia("(max-width: 767px)");
        this._handleLayoutMode();
        if (typeof this.mobileMql.addEventListener === "function") {
          this.mobileMql.addEventListener("change", this.handleLayoutMode);
        } else if (typeof this.mobileMql.addListener === "function") {
          this.mobileMql.addListener(this.handleLayoutMode);
        }
      } else {
        this.initLegacySlider();
      }
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this._onBlockSelect);
      if (this.mobileMql) {
        if (typeof this.mobileMql.removeEventListener === "function") {
          this.mobileMql.removeEventListener("change", this.handleLayoutMode);
        } else if (typeof this.mobileMql.removeListener === "function") {
          this.mobileMql.removeListener(this.handleLayoutMode);
        }
        this.mobileMql = null;
      }
      this.teardownSlider();
    }

    _handleLayoutMode() {
      if (!this.enableSlider || !this.slideContainer || !this.sliderMobileOnly) return;
      if (this.mobileMql && this.mobileMql.matches) {
        this.initMobileSlider();
      } else {
        this.teardownSlider();
      }
    }

    initMobileSlider() {
      if (this.slider) return;

      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      let __this = this;
      const prefersReducedMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const autoplayConfig =
        this.enableAutoplay && !prefersReducedMotion
          ? {
              delay: (Number.isFinite(this.autoplaySpeed) ? this.autoplaySpeed : 5) * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }
          : false;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        centeredSlides: true,
        navigation: this.navPair(prevButton, nextButton),
        loop: true,
        autoplay: autoplayConfig,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        on: {
          init: function () {
            if (__this.lastActive != null && !Number.isNaN(__this.lastActive)) {
              this.slideToLoop(__this.lastActive);
            }
            setTimeout(() => {
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton && prevButton.classList.remove("m:hidden");
                nextButton && nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
        },
      });
    }

    initLegacySlider() {
      if (this.slider) return;

      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;
      const prefersReducedMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const autoplayConfig =
        this.enableAutoplay && !prefersReducedMotion
          ? {
              delay: (Number.isFinite(this.autoplaySpeed) ? this.autoplaySpeed : 5) * 1000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }
          : false;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1,
        navigation: this.navPair(prevButton, nextButton),
        loop: true,
        autoplay: autoplayConfig,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: parseInt(this.items) - 1,
            autoplay: false,
          },
          1280: {
            slidesPerView: parseInt(this.items),
            autoplay: false,
          },
        },
        on: {
          init: function () {
            if (__this.lastActive != null && !Number.isNaN(__this.lastActive)) {
              this.slideToLoop(__this.lastActive);
            }
            setTimeout(() => {
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton && prevButton.classList.remove("m:hidden");
                nextButton && nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer && breakpointParams && typeof breakpointParams.slidesPerView !== "undefined") {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (autoplayConfig) {
        const syncMobileAutoplay = () => {
          if (!__this.slider || !__this.slider.autoplay) return;
          if (window.matchMedia("(max-width: 767px)").matches) {
            __this.slider.autoplay.start();
          } else {
            __this.slider.autoplay.stop();
          }
        };
        this.slider.on("init", syncMobileAutoplay);
        this.slider.on("breakpoint", syncMobileAutoplay);
        const mql = window.matchMedia("(max-width: 767px)");
        __this._legacyAutoplaySync = syncMobileAutoplay;
        __this._legacyAutoplayMql = mql;
        if (typeof mql.addEventListener === "function") {
          mql.addEventListener("change", syncMobileAutoplay);
        } else if (typeof mql.addListener === "function") {
          mql.addListener(syncMobileAutoplay);
        }
      }
    }

    teardownSlider() {
      if (this._legacyAutoplayMql && this._legacyAutoplaySync) {
        if (typeof this._legacyAutoplayMql.removeEventListener === "function") {
          this._legacyAutoplayMql.removeEventListener("change", this._legacyAutoplaySync);
        } else if (typeof this._legacyAutoplayMql.removeListener === "function") {
          this._legacyAutoplayMql.removeListener(this._legacyAutoplaySync);
        }
        this._legacyAutoplayMql = null;
        this._legacyAutoplaySync = null;
      }

      if (!this.slider) return;

      this.slider.destroy(true, true);
      this.slider = null;
    }

    onBlockSelect(e) {
      if (!this.slider) return;
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      this.slider.slideToLoop(index);
    }
  }

  customElements.define("m-icon-box", MIconbox);
}
